import { render, staticRenderFns } from "./RecepcionMain.vue?vue&type=template&id=009c3536&"
import script from "./RecepcionMain.vue?vue&type=script&lang=js&"
export * from "./RecepcionMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports